module.exports = __webpack_public_path__ + "static/media/Teacher.4e0f952e.png";